var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "homepage" }, [
    _c(
      "main",
      [
        _c("b-container", [
          _c("div", { staticClass: "logo-container" }, [
            _c("img", {
              attrs: { src: "/img/logo_claim.svg", alt: "skilldoo" }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "left" }, [
            _c("div", { staticClass: "bubbles" }, [
              _c(
                "a",
                {
                  staticClass: "link-bubble customer",
                  attrs: { href: _vm.urlCustomer }
                },
                [
                  _c("span", [_vm._v("Du suchst")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("Verstärkung"),
                    _c("br"),
                    _vm._v("für Euer Team")
                  ]),
                  _vm._v(" "),
                  _c("Button", {
                    staticClass: "link-bubble-button d-none d-md-inline-block",
                    attrs: {
                      href: _vm.urlCustomer,
                      icon: "caret-right",
                      text: "Passende Mitarbeiter finden"
                    }
                  }),
                  _vm._v(" "),
                  _c("Button", {
                    staticClass: "link-bubble-button d-md-none",
                    attrs: {
                      href: _vm.urlCustomer,
                      icon: "caret-right",
                      text: "Mitarbeiter finden"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "link-bubble application",
                  attrs: { href: _vm.urlApplicant }
                },
                [
                  _c("span", [_vm._v("Du suchst")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v("eine Tätigkeit"),
                    _c("br"),
                    _vm._v("für dich persönlich")
                  ]),
                  _vm._v(" "),
                  _c("Button", {
                    staticClass: "link-bubble-button d-none d-md-inline-block",
                    attrs: {
                      href: _vm.urlApplicant,
                      icon: "caret-right",
                      text: "Passenden Job finden"
                    }
                  }),
                  _vm._v(" "),
                  _c("Button", {
                    staticClass: "link-bubble-button d-md-none",
                    attrs: {
                      href: _vm.urlApplicant,
                      icon: "caret-right",
                      text: "Job finden"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "avatar" },
              [_c("Avatar", { attrs: { avatar: _vm.avatarCatNotebook } })],
              1
            )
          ])
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }